export default __webpack_public_path__ + "static/media/cross_black.c953b16d.svg";